import React, { useEffect } from "react";

export default function usePersistedState(key, defaultValue) {
  const [state, setState] = React.useState(
    () => JSON.parse(localStorage.getItem(key)) || defaultValue
  );
  
  useEffect(() => {
    if (key) localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}
